/** Textos de «Al equipo».  (spec 032, 036) */
export function textoAlEquipo(n: number): string {
    return n === 1
        ? 'Hay 1 conversación que pide al equipo.'
        : `Hay ${n} conversaciones que piden al equipo.`
}

const VENTANA_MS = 24 * 60 * 60 * 1000

/** El último mensaje del cliente en el hilo que se está mirando. */
export function ultimoClienteDeMensajes(
    mensajes: readonly { direction: string; at: string | null; papel?: string | undefined }[],
): string | null {
    let ultimo: string | null = null
    for (const m of mensajes) {
        if (m.direction !== 'in' || !m.at) continue
        if (m.papel === 'actividad' || m.papel === 'nota') continue
        if (ultimo === null || m.at > ultimo) ultimo = m.at
    }
    return ultimo
}

export function masReciente(a: string | null, b: string | null): string | null {
    if (!a) return b
    if (!b) return a
    return a > b ? a : b
}

/** Cuánto queda de la ventana de 24 h desde el último mensaje del cliente. */
export function textoVentana(iso: string | null, ahora: number = Date.now()): { abierta: boolean; texto: string } {
    if (!iso) return { abierta: false, texto: 'No se sabe si la ventana de 24 h sigue abierta.' }
    const fin = new Date(iso).getTime() + VENTANA_MS
    const queda = fin - ahora
    if (queda <= 0) return { abierta: false, texto: 'La ventana de 24 h está cerrada. Un mensaje libre no sale.' }
    const min = Math.ceil(queda / 60000)
    if (min < 60) return { abierta: true, texto: `Ventana abierta: quedan ${min} min.` }
    const h = Math.floor(min / 60)
    const rest = min % 60
    return { abierta: true, texto: rest === 0 ? `Ventana abierta: quedan ${h} h.` : `Ventana abierta: quedan ${h} h ${rest} min.` }
}

/** Cuánto lleva sin respuesta de persona. Spec 036 · FR-005. */
export function llevaEsperando(iso: string, ahora: number = Date.now()): string {
    const seg = Math.max(0, Math.floor((ahora - new Date(iso).getTime()) / 1000))
    if (seg < 60) return `Lleva ${seg} s`
    const min = Math.floor(seg / 60)
    if (min < 60) return `Lleva ${min} min`
    const h = Math.floor(min / 60)
    const minRest = min % 60
    if (h < 24) return minRest === 0 ? `Lleva ${h} h` : `Lleva ${h} h ${minRest} min`
    const d = Math.floor(h / 24)
    const hRest = h % 24
    return hRest === 0 ? `Lleva ${d} d` : `Lleva ${d} d ${hRest} h`
}

export type EstadoCitaElevada = 'reserva' | 'cancelacion' | 'modificacion' | 'ninguna'

export interface CitaElevadaVista {
    estado: EstadoCitaElevada
    fecha: string | null
    hora: string | null
    servicio: string | null
    profesional: string | null
}

const ETIQUETA_CITA: Record<EstadoCitaElevada, string> = {
    reserva: 'Tiene cita',
    cancelacion: 'Cita anulada',
    modificacion: 'Cita modificada',
    ninguna: 'No tiene cita',
}

export function describirCita(
    c: CitaElevadaVista,
    cuando: (fecha: string, hora: string) => string,
): string {
    const base = ETIQUETA_CITA[c.estado]
    if (c.estado === 'ninguna') return base
    const momento = c.fecha && c.hora ? cuando(c.fecha, c.hora) : null
    const extra = [momento, c.servicio, c.profesional].filter((x): x is string => Boolean(x))
    return extra.length === 0 ? base : `${base}: ${extra.join(' · ')}`
}
